import { Container, Grid, Typography } from '@mui/material'

const EventOrganizeTitle = ({ eventName = '' }) => {
  return (
    <Container maxWidth="ls" sx={{ pt: 2, pb: 2 }}>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Typography variant="h1" gutterBottom>
            {eventName}
          </Typography>
        </Grid>
      </Grid>
    </Container>
  )
}

export default EventOrganizeTitle